(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltacon-header"]) return;
  try {
    
  (() => {
    const init = (root) => {
      const toggle = root.querySelector('[data-vnv-toggle]');
      const panel = root.querySelector('[data-vnv-panel]');
      if (!toggle || !panel) return;

      const setOpen = (open) => {
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) panel.querySelector('a')?.focus();
      };

      toggle.addEventListener('click', () => setOpen(panel.hidden));
      panel.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); } });

      // the panel is a phone affordance; a resize back to desktop closes it
      const wide = window.matchMedia('(min-width: 990px)');
      wide.addEventListener('change', (e) => { if (e.matches && !panel.hidden) setOpen(false); });

      // compact the bar once the page has moved
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          root.classList.toggle('is-stuck', window.scrollY > 8);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    };

    document.querySelectorAll('[data-vnv]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-vnv]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltacon-news"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (rail) => {
      const scope = rail.closest('.vn');
      const arrows = scope?.querySelector('[data-vn-arrows]');
      const prev = scope?.querySelector('[data-vn-prev]');
      const next = scope?.querySelector('[data-vn-next]');
      if (!arrows || !prev || !next) return;

      const step = () => {
        const item = rail.querySelector('.vn__item');
        if (!item) return rail.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 24;
        return item.getBoundingClientRect().width + gap;
      };

      const sync = () => {
        const overflowing = rail.scrollWidth - rail.clientWidth > 4;
        arrows.hidden = !overflowing;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };

      const go = (dir) => {
        const max = rail.scrollWidth - rail.clientWidth;
        rail.scrollLeft = Math.max(0, Math.min(max, rail.scrollLeft + dir * step()));
      };
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      rail.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(rail);
      sync();
    };

    document.querySelectorAll('[data-vn-rail]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-vn-rail]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltacon-video-picker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const stage = root.querySelector('[data-vv-stage]');
      const strip = root.querySelector('[data-vv-strip]');
      if (!stage || !strip) return;

      const picks = [...strip.querySelectorAll('[data-vv-pick]')];

      // YouTube answers a request for a still that does not exist with a small
      // placeholder and a body it will happily decode, so no error event fires
      // and the size is the only reliable signal. hqdefault always exists.
      const setStill = (img, id) => {
        const hq = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
        const check = () => {
          if (img.src.endsWith('hqdefault.jpg')) return;
          if (img.naturalWidth && img.naturalWidth < 320) img.src = hq;
        };
        img.addEventListener('error', () => { if (!img.src.endsWith('hqdefault.jpg')) img.src = hq; });
        img.addEventListener('load', check);
        img.src = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
        if (img.complete) check();
      };

      const facade = (id, title) => {
        stage.innerHTML = '';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vv__play';
        btn.innerHTML =
          '<img class="vv__still" alt="" width="1280" height="720">' +
          '<span class="vv__play-badge" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" focusable="false"><path d="M8 5.5v13l11-6.5z"></path></svg></span>' +
          '<span class="vv__play-label"></span>';
        setStill(btn.querySelector('img'), id);
        btn.querySelector('.vv__play-label').textContent = title || '';
        btn.addEventListener('click', () => play(id, title));
        stage.appendChild(btn);
      };

      const play = (id, title) => {
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = title || 'Video';
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        stage.innerHTML = '';
        stage.appendChild(frame);
      };

      const select = (pick, autoplay) => {
        picks.forEach((p) => {
          const on = p === pick;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', String(on));
        });
        const id = pick.dataset.id;
        const title = pick.dataset.title;
        if (!id) return;
        if (autoplay) play(id, title); else facade(id, title);
      };

      picks.forEach((p) => p.addEventListener('click', () => {
        select(p, true);
        stage.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }));

      const first = stage.querySelector('[data-vv-play]');
      if (first && picks[0]) first.addEventListener('click', () => play(picks[0].dataset.id, picks[0].dataset.title));

      const still = stage.querySelector('[data-vv-still]');
      if (still && picks[0]) setStill(still, picks[0].dataset.id);

      const arrows = root.querySelector('[data-vv-arrows]');
      const prev = root.querySelector('[data-vv-prev]');
      const next = root.querySelector('[data-vv-next]');

      if (arrows && prev && next && picks.length > 1) {
        arrows.hidden = false;

        // Keep the chosen thumbnail in view. scrollBy with behavior:'smooth'
        // is unreliable inside a snapping container, so the position is set
        // directly and the CSS scroll-behavior does the easing.
        const reveal = (pick) => {
          const target = pick.offsetLeft - (strip.clientWidth - pick.offsetWidth) / 2;
          strip.scrollLeft = Math.max(0, Math.min(target, strip.scrollWidth - strip.clientWidth));
        };

        const step = (dir) => {
          const at = picks.findIndex((p) => p.classList.contains('is-active'));
          const to = Math.max(0, Math.min(picks.length - 1, (at < 0 ? 0 : at) + dir));
          if (to === at) return;
          // if something is already playing, keep playing through
          select(picks[to], !!stage.querySelector('iframe'));
          reveal(picks[to]);
          sync();
        };

        function sync() {
          const at = picks.findIndex((p) => p.classList.contains('is-active'));
          prev.disabled = at <= 0;
          next.disabled = at >= picks.length - 1;
        }

        prev.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        sync();
      }
    };

    document.querySelectorAll('[data-vv]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-vv]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltacon-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wire = (frame) => {
      const btn = frame.querySelector('[data-vxv-play]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const { type, id, title } = frame.dataset;
        if (!id) return;
        const src = type === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1`
          : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        const f = document.createElement('iframe');
        f.src = src;
        f.title = title || 'Video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        frame.innerHTML = '';
        frame.appendChild(f);
      });
    };
    document.querySelectorAll('[data-vxv-frame]').forEach(wire);
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-vxv-frame]').forEach(wire));
  })();

  } catch(e) { console.error(e); }
})();
})();
